export interface Feedback {
  reason: string;
  rating: number;
  description: string;
  anonymous: boolean;
  url: string;
}
